import { Component, input, inject } from '@angular/core';
import { FormGroupDirective, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MobilBytteSelectors } from '@app/sales/modules/mobilephone/states/mobilbytte/mobilbytte.selectors';
import { IceAlertComponent } from '@app/shared/components/molecules/ice-alert/ice-alert.component';
import { IceCheckboxComponent } from '@app/shared/components/molecules/ice-checkbox/ice-checkbox.component';
import { IconNames } from '@app/shared/enums/icon-names';
import { select } from '@ngxs/store';

export type SummaryRow = { damageReason: string; hasDamage: boolean };

@Component({
  selector: 'app-summary-step',
  imports: [IceAlertComponent, IceCheckboxComponent, ReactiveFormsModule],
  templateUrl: './summary-step.component.html',
  styleUrl: './summary-step.component.scss',
})
export class SummaryStepComponent {
  private formGroupDirective = inject(FormGroupDirective);
  data = inject<{
    equipmentUpgradeAgreementId: number;
  }>(MAT_DIALOG_DATA);

  IconNames = IconNames;

  existingEquipmentUpgradeAgreements = select(MobilBytteSelectors.existingEquipmentUpgradeAgreements);

  summaryRows = input.required<SummaryRow[]>();
  isPhoneDamaged = input.required<boolean>();

  get isCustomerInformed(): FormControl {
    return this.formGroupDirective.form?.controls?.isCustomerInformed as FormControl;
  }

  get hasInsurance(): boolean {
    const equipmentUpgradeAgreementId = this.data?.equipmentUpgradeAgreementId;
    if (!equipmentUpgradeAgreementId) {
      return false;
    }

    return !!this.existingEquipmentUpgradeAgreements().find(
      agreement => +agreement?.agreementId === equipmentUpgradeAgreementId
    )?.insuranceServiceId;
  }
}
